<template>
<div>
<KullaniciFormResultDataView :Admin="true"></KullaniciFormResultDataView>
</div>

    <!-- <v-card>

  <v-dialog
      v-model="dialog"
      width="1200"
    >
     

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Privacy Policy
        </v-card-title>

        <v-card-text>   
            :rows="['username']"
    :cols="['formSavedId']"
             :data="[{color: 'blue', shape: 'circle'},{color: 'red', shape: 'triangle'}]"
          <vue-pivottable-ui
          
    

:data="result.rows"
  
      
 
  >
  </vue-pivottable-ui>
   </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            I accept
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

        <v-toolbar dark color="primary">

            <v-toolbar-title> {{ result.formname }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn dark icon @click="excelAktar" v-bind="attrs" v-on="on">

                            <v-icon>mdi-database-export</v-icon>
                        </v-btn>
                    </template>
                    <span>Excel Aktar</span>
                </v-tooltip>
                <v-btn
              dark
              text
              @click="dialog = true"
            >
          Pivot
              
            </v-btn>
            </v-toolbar-items>
        </v-toolbar>


        <v-card-text>
            <div class="v-data-table theme--light">
                <div class="v-data-table__wrapper">
                  
                    <table id="tblFormData" class="myTable">

                        <thead>
                            <tr>
                                <th>Kullanıcı</th>
                                <th>Kullanıcı Ad Soyad</th>
                                <th>Başvuru Tarihi</th>
                                <th class="text-left" v-for="(item) in header" :key="item.ogeId">
                                    {{ item.header }}
                                </th>
                              
                            </tr>
                        </thead>
                        <tbody>
         
                            <tr v-for="item in result.rows" :key="item.formSavedId">
                                <td>{{ item.username }} </td>
                                <td>{{ item.username2 }} </td>
                                <td>{{ item.date }}</td>
                                <td v-for="itemrow in item.columns" :key="itemrow.ogeId">
                              
                                               <div v-if="itemrow.tur == 1">
                                    <a target="_blank" :href="`../` + itemLink"
                                        v-for="(itemLink, indexLink) in itemrow.value.split(',')"
                                        :key="itemLink">Dosya_{{ indexLink }}</a>
                                </div>
                                <div v-else>
                                    {{ itemrow.value }}
                                </div>
                                </td>

                            </tr>
                        </tbody>

                    </table>
                </div>
            </div>

        </v-card-text>

        <v-divider></v-divider>

      
    </v-card> -->

</template>
<script>
//import router from '@/router';
import { tableToExcel } from '@/plugins/custom';

import FormService from '@/services/FormService';

// import { VuePivottableUi,TableRenderers    } from 'vue-pivottable'

import PlotlyRenderer from '@vue-pivottable/plotly-renderer'

import 'vue-pivottable/dist/vue-pivottable.css'
import KullaniciFormResultDataView from '../components/KullaniciFormResultDataView.vue';
//-------------------------------------------
//import { PlotlyRenderers } from '@vue-pivottable/plotly-renderer'


// Plotly renderer'ları initialize et



export default {
    name: "FormListesi",
    components:{ KullaniciFormResultDataView },
    data() {
        return {
                   customRenderers: {...PlotlyRenderer},

            dialog:false,
            result: {
                formname: "",
                rows: [

                ]
            },
            values: [],
        }
    },
    created() {
       // this.dataBind();

    },
    methods: {
        excelAktar() {
            // console.log("object,", document.getElementById("tblFormDataHeader").parentElement);
            tableToExcel("tblFormData", this.result.formname);
        },
        dataBind() {
            console.log("this.dataBind,", this.$route.params);
            FormService.listFormResultDataItems(this.$route.params.id).then((result) => {
                console.log("result,", result.data);
                this.result = result.data;
            }).catch((err) => {

            });
        },
        // editItem(v) {
        //   router.push({ name: 'formgosterim', params: { id: v.id } })
        // },
        // formTasarimGonder(v) {
        //   console.log("formTasarimGonder");
        //   router.push({ name: 'formtasarimi', params: { id: v.id } })
        // }
    }, computed: {
        header() {

            console.log("header", this.result);
            if (this.result.rows.length > 0) {
                console.log("object", this.result.rows[0].columns);
                return this.result.rows[0].columns;
            }
            return [];

        },
          renderers () {
      return (() => ({
        'Grouped Column Chart': PlotlyRenderer['Grouped Column Chart'],
        'Stacked Column Chart': PlotlyRenderer['Stacked Column Chart'],
        'Grouped Bar Chart': PlotlyRenderer['Grouped Bar Chart'],
        'Stacked Bar Chart': PlotlyRenderer['Stacked Bar Chart'],
        'Line Chart': PlotlyRenderer['Line Chart'],
        'Dot Chart': PlotlyRenderer['Dot Chart'],
        'Area Chart': PlotlyRenderer['Area Chart'],
        'Scatter Chart': PlotlyRenderer['Scatter Chart'],
        'Multiple Pie Chart': PlotlyRenderer['Multiple Pie Chart']
      }))()
    }
    },
}
</script>
<style scoped>
.myTable tbody {
    height: calc(100vh - 250px);
    overflow-y: auto;
}


</style>